<app-call-waiter-indicator
  type="bill"
  class="bell"
  [class.active]="callWaiterRequestBill()"
/>

@if (callWaiterRequestBill()) {
  <div class="info">
    <span>Your bill has been requested and will be dropped off shortly.</span>
    <span class="sub">Tap to cancel.</span>
  </div>
} @else {
  <span class="text">Request bill</span>
}
